import React, { useCallback, useMemo } from 'react';
import { Box } from '@material-ui/core';
import { CommonDataGrid } from 'features/shared/components/table';
import {
  BOOKING_COLUMNS,
  BOOKING_CHARGE_COLUMNS,
} from '../../constants/personBookingDetailsConstants';
import { parseRelatedRecordRows } from '../../utility/personRelatedRecordsHelper';

const BookingCharges = ({ rows }) => {
  return (
    <Box p={2} className="person-booking-details__charges">
      <CommonDataGrid
        rows={rows}
        columns={BOOKING_CHARGE_COLUMNS}
        toolbar={{ showToolbar: false }}
        pagination={{ enabled: false }}
        hideFooter
        storageKey="person-booking-charges"
      />
    </Box>
  );
};

const PersonBookingDetails = ({ data }) => {
  const rows = useMemo(
    () =>
      parseRelatedRecordRows(data).map((row, index) => ({
        ...row,
        id: row.ptsBookingID ?? row.id ?? `${row.BookingAgencyID}-${row.BookingID}-${index}`,
        Charges: parseRelatedRecordRows(row.Charges).map((charge, chargeIndex) => ({
          ...charge,
          id: charge.ptsChargeID ?? charge.id ?? chargeIndex,
        })),
      })),
    [data]
  );

  const renderContent = useCallback(({ row }) => <BookingCharges rows={row.Charges} />, []);

  const expandableRows = useMemo(() => ({ renderContent, getHeight: 300 }), [renderContent]);

  return (
    <CommonDataGrid
      className="person-booking-details__bookings"
      rows={rows}
      columns={BOOKING_COLUMNS}
      expandableRows={expandableRows}
      storageKey="person-bookings"
    />
  );
};

export default PersonBookingDetails;
